import './Sidebar.css';
import { useAuth } from '../../auth/AuthContext';
import SubmissionHistory from '../teacher/SubmissionHistory';
import TeamAssignments from '../chef/TeamAssignments';
import PerformanceMetrics from '../chef/PerformanceMetrics';

export default function Sidebar({ active = 'dashboard', onNavigate, history = [], team = [], performanceRate = 0, performanceDelay = 0, showHistory = true }) {
  const { user } = useAuth();
  const isChef = user?.role_nom === 'chef';
  const isTeacher = user?.role_nom === 'enseignant';

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <span className="logo">VeriPlan</span>
      </div>

      <nav className="sidebar-menu">
        {/* Navigation pour enseignant */}
        {user?.role_nom === 'enseignant' && (
          <>
            <button
              className={`sidebar-link ${active === 'dashboard' ? 'active' : ''}`}
              onClick={() => onNavigate?.('dashboard')}
              type="button"
            >
              Tableau de bord
            </button>
            <button
              className={`sidebar-link ${active === 'plans' ? 'active' : ''}`}
              onClick={() => onNavigate?.('plans')}
              type="button"
            >
              Mes plans
            </button>
            <div className="sidebar-group">
              <button
                className={`sidebar-link ${active === 'submit' ? 'active' : ''}`}
                onClick={() => onNavigate?.('submit')}
                type="button"
              >
                Soumettre un plan
              </button>
              <span className="sidebar-sub">Nouveau plan</span>
            </div>
          </>
        )}

        {/* Navigation pour chef d'équipe */}
        {user?.role_nom === 'chef' && (
          <>
            <button
              className={`sidebar-link ${active === 'dashboard' ? 'active' : ''}`}
              onClick={() => onNavigate?.('dashboard')}
              type="button"
            >
              Tableau de bord
            </button>
            <button
              className={`sidebar-link ${active === 'queue' ? 'active' : ''}`}
              onClick={() => onNavigate?.('queue')}
              type="button"
            >
              File d'attente
            </button>
          </>
        )}

        {/* Navigation pour conseiller pédagogique */}
        {user?.role_nom === 'conseiller' && (
          <>
            <button
              className={`sidebar-link ${active === 'dashboard' ? 'active' : ''}`}
              onClick={() => onNavigate?.('dashboard')}
              type="button"
            >
              📚 Plans en analyse
            </button>
            <button
              className={`sidebar-link ${active === 'validation' ? 'active' : ''}`}
              onClick={() => onNavigate?.('validation')}
              type="button"
            >
              ✓ Validation pédagogique
            </button>
          </>
        )}

        {/* Navigation pour direction adjointe */}
        {(user?.role_nom === 'direction_adjointe' || user?.role_nom === 'directeur_adjoint' || user?.role_nom?.toLowerCase().includes('directeur')) && (
          <>
            <button
              className={`sidebar-link ${active === 'stats' ? 'active' : ''}`}
              onClick={() => onNavigate?.('stats')}
              type="button"
            >
              📊 Tableau de bord
            </button>
            <button
              className={`sidebar-link ${active === 'dashboard' ? 'active' : ''}`}
              onClick={() => onNavigate?.('dashboard')}
              type="button"
            >
              📋 Plans à approuver
            </button>
            <button
              className={`sidebar-link ${active === 'roles' ? 'active' : ''}`}
              onClick={() => onNavigate?.('roles')}
              type="button"
            >
              👥 Gestion des rôles
            </button>
          </>
        )}

        {/* Navigation générique pour autres rôles */}
        {!['enseignant', 'chef', 'conseiller', 'direction_adjointe', 'directeur_adjoint'].includes(user?.role_nom) && 
         !user?.role_nom?.toLowerCase().includes('directeur') && (
          <>
            <button
              className={`sidebar-link ${active === 'dashboard' ? 'active' : ''}`}
              onClick={() => onNavigate?.('dashboard')}
              type="button"
            >
              Tableau de bord
            </button>
            <button
              className={`sidebar-link ${active === 'plans' ? 'active' : ''}`}
              onClick={() => onNavigate?.('plans')}
              type="button"
            >
              Plans
            </button>
          </>
        )}
      </nav>

      {/* Pour les chefs d'équipe: afficher les widgets */}
      {isChef && team && team.length > 0 && (
        <div className="sidebar-widgets">
          <TeamAssignments team={team} />
          <PerformanceMetrics rate={performanceRate} delay={performanceDelay} />
        </div>
      )}

      {showHistory && isTeacher && <SubmissionHistory history={history} />}

      <div className="sidebar-footer">
        <div className="user-block">
          <div className="avatar">{user?.nom?.slice(0, 1) || 'U'}</div>
          <div>
            <p className="user-name">{user?.nom || 'Utilisateur'}</p>
            <p className="user-role">{user?.role_nom || ''}</p>
          </div>
        </div>
      </div>
    </aside>
  );
}
